$(document).ready(function () {
  $("div#one-click-popup-main-content .dismissal").click(function () {
    $("#one-click-popup-main-content").fadeOut(500);
  });

  // $(window).scroll(function () {
  //     var sticky = $(".header-sticky-wrapper"),
  //         scroll = $(window).scrollTop();

  //     if (scroll >= 20) sticky.addClass("blinix-sticky");
  //     else sticky.removeClass("blinix-sticky");
  // });

  var windowsize = $(window).width();

  $(window).resize(function () {
    var windowsize = $(window).width();
  });

  // if (windowsize > 770) {
  //   var maxHeight = 0;

  //   $(".blinix-faqs-hp .bottom-warpper .headline-warpper").each(function () {
  //     var height = $(this).height();
  //     if (height > maxHeight) {
  //       maxHeight = height;
  //     }
  //   });
  // }

  // $(".blinix-faqs-hp .bottom-warpper .headline-warpper").height(maxHeight);

  // var lastScrollTop = 0;

  // $(window).scroll(function () {
  //     var currentScrollTop = $(window).scrollTop();
  //     var headerStickyWrapper = $(".header-sticky-wrapper");
  //     if (currentScrollTop > lastScrollTop) {
  //         headerStickyWrapper.removeClass("blinix-sticky");
  //     } else {
  //         if (currentScrollTop >= 20) {
  //             headerStickyWrapper.addClass("blinix-sticky");
  //         } else {
  //             headerStickyWrapper.removeClass("blinix-sticky");
  //         }
  //     }

  //     lastScrollTop = currentScrollTop;
  // });

  $(".blinix-faqs-hp .full-des").hide();
  $(".blinix-faqs-hp .see-less-button").hide();

  $(".blinix-faqs-hp .see-more-button").click(function () {
    $(this).hide();

    var colWrapper = $(this).closest(".col-warpper");
    colWrapper.find(".see-less-button").show();

    colWrapper.find(".half-des").hide();
    colWrapper.find(".full-des").show();
  });

  $(".blinix-faqs-hp .see-less-button").click(function () {
    $(this).hide();

    var colWrapper = $(this).closest(".col-warpper");
    colWrapper.find(".see-more-button").show();
    colWrapper.find(".half-des").show();
    colWrapper.find(".full-des").hide();
  });
  // Home Page Slider Js for why-better-section
  if (windowsize < 840) {
    setTimeout(function () {
      $(".why-better-section .row-warpper").owlCarousel({
        stagePadding: 10,
        loop: false,
        arrow: false,
        dots: true,
        margin: 0,
        nav: true,
        items: 1,
      });
    }, 500);
  }
  // Home Page Slider Js for blinix-faqs-hp section

  if (windowsize > 300) {
    setTimeout(function () {
      $(".blinix-faqs-hp .row-warpper").owlCarousel({
        stagePadding: 10,
        loop: false,
        arrow: false,
        dots: true,
        margin: 0,
        nav: true,
        responsive: {
          0: {
            items: 1,
          },

          800: {
            items: 3,
          },
          1024: {
            items: 4,
          },
        },
      });
    }, 300);
  }

  if (windowsize > 770 && windowsize <= 998) {
    setTimeout(function () {
      $(
        ".template-product .blinix-faqs-hp .row-warpper , #shop-premium-sukkah-collection-sukkahco .blinix-faqs-hp .row-warpper"
      ).owlCarousel({
        stagePadding: 30,
        loop: false,
        arrow: false,
        dots: true,
        margin: 0,
        nav: true,
        items: 2,
      });
    }, 300);
  }

  if (windowsize > 998) {
    setTimeout(function () {
      $(
        ".template-product .blinix-faqs-hp .row-warpper , #shop-premium-sukkah-collection-sukkahco .blinix-faqs-hp .row-warpper"
      ).owlCarousel({
        stagePadding: 30,
        loop: false,
        arrow: false,
        dots: true,
        margin: 0,
        nav: true,
        items: 5,
      });
    }, 300);
  }

  setInterval(function () {
    var nextItem = $(".slider_item.animated.fadeInRight")
      .fadeOut()
      .removeClass("animated fadeInRight")
      .next(".slider_item");

    if (nextItem.length === 0) {
      nextItem = $(".slider_item").first();
    }

    nextItem.fadeIn().addClass("animated fadeInRight");
  }, 1500);

  $("#HeaderWrapper .site-nav li .site-nav__link")
    .filter(function () {
      return this.href === location.href;
    })
    .addClass("active");

  // faqs js
  $(".acc-container .acc:nth-child(1) .acc-head").addClass("active");
  $(".acc-container .acc:nth-child(1) .acc-content").slideDown();
  $(".acc-head").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).siblings(".acc-content").slideUp();
      $(this).removeClass("active");
    } else {
      $(".acc-content").slideUp();
      $(".acc-head").removeClass("active");
      $(this).siblings(".acc-content").slideToggle();
      $(this).toggleClass("active");
    }
  });

  // jquery check if text is empty condition
  $(".acc-container .acc-head span").each(function () {
    if ($(this).html().trim() == "") {
      $(this).parent().parent().hide();
    }
  });

  if ($("#product-redirect-01").length) {
    $("#product-redirect-01").on("click", function () {
      location.href =
        "https://sukkahco.com/products/mehadrin-bamboo-mats-sukkah";
    });
  }

  if ($("#product-redirect-02").length) {
    $("#product-redirect-02").on("click", function () {
      location.href = "https://sukkahco.com/pages/shop-sukkah-decorations";
    });
  }

  var spanElement = $("<span>", {
    "data-product-price": "",
    class: "product__price on-sale",
    text: "(Free Shipping)",
  });

  $(".page-content--product .product-block.product-block--price").append(
    spanElement
  );

  if (windowsize < 600) {
    setTimeout(function () {
      $(".blinix-recommended-products .row-warpper").owlCarousel({
        stagePadding: 0,
        loop: false,
        arrow: false,
        dots: false,
        margin: 0,
        nav: true,
        items: 3,
      });
    }, 300);
  }

  if (windowsize > 600) {
    setTimeout(function () {
      $(".blinix-recommended-products .row-warpper").owlCarousel({
        stagePadding: 0,
        loop: false,
        arrow:true,
        dots: false,
        margin: 0,
        nav: true,
        items: 5,
      });
    }, 300);
  }

  // $(".blinix-product-page-faqs div:first").css("display", "block");

  $(".blinix-product-page-faqs span").click(function () {
    // $(".blinix-product-page-faqs h3").find("i").css({'transform':'rotate(0deg)'});
    $(this).next().slideToggle(500);

    $(".blinix-product-page-faqs div").not($(this).next()).slideUp(500);
  });

  var $faqs = $(".blinix-faqs-hp");

  if ($faqs.length > 1) {
    $faqs.last().css("padding-top", "0");
  }
    
  $('select[name*="contact[Sukkahheight]"]').change(function(){
  	if($(this).val() == '10ft') {
  		$('select[name*="contact[Sukkahwalls]"] option[value="3"]').attr('disabled', true);
  		$('select[name*="contact[Sukkahwalls]"] option[value="3"]').attr('style', 'display:none');
  		if($('select[name*="contact[Sukkahwalls]"]').find('option:selected').val() == '3'){
  			$('select[name*="contact[Sukkahwalls]"]').prop("selectedIndex", 0).val();
  		}
  	} else {
  		$('select[name*="contact[Sukkahwalls]"] option[value="3"]').removeAttr("disabled");
  		$('select[name*="contact[Sukkahwalls]"] option[value="3"]').attr('style', 'display:block');
  	}
  });
  
  function headerSize() {
  	var $headerHeight = $('div#shopify-section-header').outerHeight();
  	$('.header-scroll  #PageContainer').css('padding-top', $headerHeight);
  }
  $(window).on("load", headerSize);
  //$(window).on("resize", $.debounce(500, headerSize));
  
  $(window).scroll(function() {
  	scroll = $(window).scrollTop();
  	if (scroll >= 1) {
  	  $('.site-header').css('top', '0');
  	  $('body').addClass("header-scroll");
  
  	} else {
  	  $('.site-header').css('top', 'initial');
  	  $('body').removeClass("header-scroll");
  	}
  });
    
});


$(document).ready(function () {
    function initializeSlickSlider() {
        if ($(window).width() < 768) {
            if (!$('#info-contact-page .blinix-row').hasClass('slick-initialized')) {
                $('#info-contact-page .blinix-row').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true,
                });
            }
        } else {
            if ($('#info-contact-page .blinix-row').hasClass('slick-initialized')) {
                $('#info-contact-page .blinix-row').slick('unslick');
            }
        }
    }

    // Initialize slider on page load
    initializeSlickSlider();

    // Reinitialize slider on window resize
    $(window).resize(function () {
        initializeSlickSlider();
    });
});





